import { useState, useEffect } from 'react';

const useMounted = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return isMounted;
};

export { useMounted as default };
//# sourceMappingURL=src-hooks-useMounted.js.map
